import FormDimensionsInput from './FormDimensionsInput';

export type { FormDimensionsInputProps } from './FormDimensionsInput';

export default FormDimensionsInput;
